import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiLinearProgress from '@material-ui/core/LinearProgress';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { LinearProgressStyle } from './styles';
import { RcLinearProgressClasses } from './utils';
var _RcLinearProgress = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcLinearProgress' });
    var classesProp = props.classes, color = props.color, rest = __rest(props, ["classes", "color"]);
    var classes = useMemo(function () { return combineClasses(RcLinearProgressClasses, classesProp); }, [classesProp]);
    return React.createElement(MuiLinearProgress, __assign({}, rest, { ref: ref, classes: classes }));
});
var RcLinearProgress = styled(_RcLinearProgress)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), LinearProgressStyle);
RcLinearProgress.defaultProps = {
    color: 'interactive.f01',
};
RcLinearProgress.displayName = 'RcLinearProgress';
export { RcLinearProgress };
var templateObject_1;
